
export default function CtaFinal() {
  return (
    <section className="relative py-32 overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/764e928d88fe41be7ac3fed5fe148591.jpg)'
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-white mb-6 leading-tight">
          Você não precisa enfrentar tudo sozinho(a)
        </h2>
        <p className="text-lg md:text-xl text-white/90 mb-10 max-w-2xl mx-auto font-light">
          Buscar ajuda é um ato de autocuidado e coragem. Dê o primeiro passo em direção ao seu bem-estar emocional.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="https://wa.me/5511959099459"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#A8D5E2] text-gray-800 px-8 py-4 rounded-full text-base font-medium hover:bg-[#8FC5D4] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Agendar Sessão
          </a>
          <a
            href="https://wa.me/5511959099459"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full text-base font-medium hover:bg-white/20 transition-all duration-300 border border-white/30 whitespace-nowrap cursor-pointer"
          >
            WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
